const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  description: 'p=>p.Description',
  serverId: 'p=>p.ServerId',
  serverSideName: 'p=>p.ServerSideName',
}

export const mapSortCameraParam = (key: string) => mapping[key]
